import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';

function IntroSection() {
  return (
    <section className="py-12 sm:py-16 md:py-28">
      <div className="container-site mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="Anspruch"
            title="Wenn Beton kommt, muss die Baustelle bereit sein."
            compact
          />
        </Reveal>
        <Reveal delay={100}>
          <div className="max-w-[760px] mt-6 text-ink-soft text-base sm:text-lg leading-relaxed">
            <p>
              Bauherren, Baumeister und Sanierer brauchen einen Partner, der nicht nur liefert, sondern mitdenkt –
              von der Zufahrt bis zur letzten Schubkarre.
            </p>
            <p className="mt-4">
              Genau dafür ist MH-BETON gemacht: Leistung wählen, Eckdaten klären, Termin fixieren, sauber einbringen.
              Ohne Umwege, ohne Improvisation.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default IntroSection;
